import Api from "./Api";
export default {
  run(storeId) {
    const params = storeId ? `?storeId=${storeId}` : "";
    return Api().post(`/log-analysis/run${params}`);
  },
  paginate(paginate) {
    return Api().post("/log-analysis/page", paginate);
  },
  getIssues(id) {
    return Api().get(`/log-analysis/${id}/issues`);
  },
};
